




import VueOptions from '@utils/VueOptions'
import EventCampaignSelector from '@superComponents/Event/EventCampaignSelector'

settings = 
  name: "EventCampaignSelectorPage"
  components: { EventCampaignSelector }
  vue:
    computed:
      events: ->
        @$route.params.events

export default VueOptions.vue settings
